import styled from "@emotion/styled"
import tw from "twin.macro"

// export const styles = {
//   H1: tw`font-body text-26 tracking-ease leading-1.08 md:text-40 md:tracking-relaxed md:leading-1.05`,
//   H2: tw`font-body text-24 tracking-ease leading-1.2 md:text-26 md:leading-1`,
//   H3: tw`font-display text-16 tracking-wide leading-1.28 md:text-18 md:tracking-widest md:leading-1.22`,
//   H4: tw`font-label text-18 tracking-looser leading-1.43 md:text-18 md:tracking-loosest md:leading-1.11`,
//   P: tw`font-body text-16 leading-1.28 md:text-18`,
//   Large: tw`font-body text-40 tracking-relaxed md:text-70 md:tracking-loose`,
//   Small: tw`font-display text-12 tracking-looser leading-1.43 md:text-14 md:tracking-loosest md:leading-1.11`,
// }

export const styles = {
  H1: tw`font-body text-26 tracking-ease leading-1.08 md:text-40 md:tracking-relaxed md:leading-1.05`,
  H2: tw`font-body text-20 tracking-ease leading-1.2 md:text-26 md:leading-1`,
  H3: tw`font-display text-14 tracking-wider leading-1.28 md:text-18 md:tracking-widest md:leading-1.22`,
  H4: tw`font-label text-14 tracking-looser leading-1.43 md:text-18 md:tracking-loosest md:leading-1.11`,
  P: tw`font-body text-16 leading-1.28 md:text-18`,
  Large: tw`font-body text-40 tracking-relaxed md:text-70 md:tracking-loose`,
  Small: tw`font-display text-10 tracking-wide leading-1.43 md:text-14 md:tracking-wider md:leading-1.11`,
}

export const StyledH1 = styled.h1<TextProps>`
  ${styles.H1}
`
export const StyledH2 = styled.h2<TextProps>`
  ${styles.H2}
`
export const StyledH3 = styled.h3<TextProps>`
  ${styles.H3}
`
export const StyledH4 = styled.h4<TextProps>`
  ${styles.H4}
`
export const StyledH5 = styled.h5<TextProps>`
  ${styles.H1}
`
export const StyledH6 = styled.h6<TextProps>`
  ${styles.H2}
`
export const StyledP = styled.p<TextProps>`
  ${styles.P}
`
export const StyledLabel = styled.p<TextProps>`
  ${styles.P}
`
export const StyledSmall = styled.p<TextProps>`
  ${styles.Small}
`
export const Blockquote = styled.p<TextProps>`
  ${styles.Small}
`
export const StyledLarge = styled.h1<TextProps>`
  ${styles.Large}
`
export const RichTextContent = styled.div<TextProps>`
  ${styles.P}
  > *, br, > div > * {
    ${tw`mb-2 last:mb-0`}
  }
  small {
    ${tw`block text-12 md:text-14 text-dark`}
  }
  li {
    ${tw`mt-1 list-disc`}
  }
  > ul,
  > ol {
    ${tw`ml-5`}
  }
`

type TextProps = {
  as?: any
  to?: any
}
